import { useEffect, useRef } from 'react';
import { CrmService } from '../../../../services/CrmService';
import { AdminService } from '../../../../services/AdminService';
import { CommonService } from "../../../../services/CommonService";
import { ChangeAlertCallbackType } from "../../../Root";

export const useCRMFunction = (changeAlert: ChangeAlertCallbackType) => {
    const crmService = useRef<CrmService>();
    const commonService = useRef<CommonService>();
    const adminService = useRef<AdminService>();

    // GET __________________________________________________
    
    const handleLeadData = async (payload, service) => {
        const response = await crmService.current[service](payload);
        if (response['data']?.response === 'OK') {
            return (response.data['content'] ? response.data : response.data.widget.length > 0 ? response.data.widget[0].data : { content: [] });
        } else {
            changeAlert(true, 'error', response['data'].message || 'Error al consultar servicio');
            return false;
        }
    };

    const handleLeadByUuid = async (uuid, tab) => {
        let req = { filters: { uuid: uuid }}
        let service = tab === 'contact' ? 'leadContactCrmGet' : 'leadCrmGet';

        const response = await crmService.current[service](req);
        if (response['data']?.response === 'OK') {
            return (response.data['content']);
        } else {
            changeAlert(true, 'error', response['data'].message || 'Error al consultar servicio');
            return false;
        }
    };

    const handlePartner = async (section, lead, page, perPage) => {
        let service = section === 'company' ? 'leadContactCrmList' : 'leadCrmList'
        let search = section === 'company' ? 'partner_contact' : 'partner_company'
        let f = {
            filters: {},
            pagination: {page_number: page, results_per_page: perPage}
        };
        
        f['filters'][search] = lead[search]
    
        if(lead[search] && lead[search].length > 0){
            const response = await crmService.current[service](f);
    
            if (response['data']?.response === 'OK') {
                let resp = response.data['content'] ? response.data : response.data.widget.length > 0 ? response.data.widget[0].data : { content: [] }
                if(resp['content'].length > 1 && lead["ppal_contact"]){
                    resp['content'].unshift(resp['content'].splice(resp['content'].findIndex(e => e.uuid === lead["ppal_contact"]["uuid"]), 1)[0])
                }
                return (resp);
            } else {
    
                changeAlert(true, 'error', (response['data'] && response['data'].message) || 'Error al consultar servicio');
                return ({ content: [] });
            }
        }  else {
            return null;
        }
    };

    const handleAgentList = async (crmType) => {
        let role = ''
        switch (crmType) {
            case 'afb':
                role = 'inext-role-afb-kam'
                break;
        }

        const response = await adminService.current.agentByRoleList(role);
        if (response["data"]?.response === "OK") {
            return (JSON.parse(JSON.stringify(response.data.content)));
        } else {
            changeAlert(true, "error", response["message"] || response["data"]['message'] || "Error al consultar servicio");
            return false;
        };
    };

    const handleRevenue = async (type) => {
        let req = {
            filters: {
                funnelKeys: []
            }
        }

        console.log('');
        (type)["crmLowFunnel"].map((i) => req.filters.funnelKeys.push(i.key))
   
        const response = await crmService.current["leadCrmRevenueGet"](req);
        if (response['data']?.response === 'OK') {
            return(response.data['content'][0] || [] );
        } else {
            changeAlert(true, 'error', response['data'].message || 'Error al consultar servicio');
            return false;
        }
    };

    const handleCatalog = async (type: string, metadata?) => {
        let data = {
            catalog: {
                id: type
            },
        };
        if (metadata) {
            data.catalog['filters'] = metadata
        }

        const response = await commonService.current.getCatalog(data);
        if(response?.data?.response === 'OK'){
            return (response.data.catalog);
        } else {
            changeAlert(true, 'error', 'Ocurrió un error, ' + response.data.message);
            return false;
        }
    };

    // UPDATE __________________________________________________
    
    const onHandleChangeAgent = async (newAgent, section, lead, agent) => {
        let service = section === 'company' ? 'leadCrmUpdateAgent' : 'leadContactCrmUpdateAgent'
        let req = {
            data: {
                uuid: lead['uuid'],
                agent: newAgent
            },
            agent: {
                uuid: agent['uuid'],
                email: agent['email'],
                name: agent['name']
            }
        }

        const response = await crmService.current[service](req);
        if (response['data']?.response === 'OK') {
            changeAlert(true, 'success', 'Agente asignado con éxito.');
            return true;
        } else {
            changeAlert(true, 'error', response['message'] || response['data'].message || 'Error al asignar agente');
            return false;
        }
    };

    const onHandleChangeStatus = async (section, key, value, lead, agent, form?) => {
        let service = section === 'company' ? 'leadCrmUpdate' : 'leadContactCrmUpdate'

        let req = {}
        if (form) {
            req = form
        }
        req['data'] ? req['data']['uuid'] = lead['uuid'] : req['data'] = {uuid: lead['uuid']}
        req['agent'] = {
            uuid: agent['uuid'],
            email: agent['email'],
            name: agent['name']
        }


        if(key && value){
            req['data'][key] = value;
        }

        const response = await crmService.current[service](req);
        if (response['data']?.response === 'OK') {
            changeAlert(true, 'success', 'Registro actualizado con éxito');
            return true;
        } else {
            changeAlert(true, 'error', response['message'] || response['data'].message || 'Error al cambiar estatus');
            return false;
        }
    }

    const onHandleUpdateCompanyContact = async (row, lead, agent) => {
        let service = 'leadCrmUpdate'

        let req = {
            data: {
                uuid: lead['uuid'],
                ppal_contact: {
                    uuid: row["uuid"],
                    name: `${row["general"]["gname"]} ${row["general"]["lname"]}`,
                }
            },
            agent: {
                uuid: agent['uuid'],
                email: agent['email'],
                name: agent['name']
            },
        }

        const response = await crmService.current[service](req);
        if (response['data']?.response === 'OK') {
            changeAlert(true, 'success', 'Contacto principal actualizado con éxito');
            return true;
        } else {
            changeAlert(true, 'error', response['message'] || response['data'].message || 'Error al cambiar estatus');
            return false;
        }
    };

    const onHandleLeadUpdate = async (form) => {
        let req =  form;

        const response = await crmService.current.leadCrmUpdate({data: req});
        if (response['data']?.response === 'OK') {
            changeAlert(true, 'success', 'Registro actualizado con éxito');
            return true;
        } else {
            changeAlert(true, 'error', response['message'] || response['data'].message || 'Error al cambiar estatus');
            return false;
        }
    };

    // TASKS __________________________________________________
    const onHandleGetTasks = async (lead, data, type, page, perPage, pplTab) => {
        let request = {
            filters: {
                lead_uuid: typeof lead === "string" ? data["uuid"] || data["lead_uuid"] || data["data"]["lead_uuid"] : lead["uuid"] || lead['lead_uuid'] || lead["data"]["lead_uuid"],
                // app_uuid: lead["app_uuid"],
                archived: false,
                type: pplTab
            },
            pagination: {
                page_number: page,
                results_per_page: perPage,
            }
        };

        switch (type) {
            case "current":
                pplTab === "meet" && (request["filters"]["is_completed"] = false)
                break;
            case "to_do":
                request["filters"]["is_completed"] = false;
                break;
            case "history":
                request["filters"]["is_completed"] = true;
                // request["filters"]["archived"] = true;
                break;
        }

        const response = await crmService.current.taskCrmList(request);
        if (response.data?.response === "OK") {
            return (response.data)
        } else {
            changeAlert(true, "error", response.data?.message || response.message || "Error al obtener tareas");
            return false;
        }
    };

    const onHandleCreateTasks = async (newTask) => {
        const response = await crmService.current.taskCrmCreate(newTask);
        if (response.data?.response === "OK") {
            changeAlert(true, 'success', 'La actividad se registró con éxito');
            return true;
        } else {
            changeAlert(true, "error", response.data?.message || response.message || "Error al obtener tareas");
            return false;
        }
    };

    const onHandleAddCommentTask = async (comment, editTask, agent) => {
        let request = {
            uuid: editTask['uuid'],
            lead_uuid: editTask['lead_uuid'],
            comment: {
                agent: {
                    uuid: agent['uuid'],
                    email: agent['email'],
                    name: agent['name']
                },
                text: comment['content'],
                cdate: new Date().toJSON()
            }
        }

        const response = await crmService.current.taskCrmCommentAdd({data: request});
        if (response.data?.response === "OK") {
            changeAlert(true, 'success', 'El registro se creó con éxito');
            return true;
        } else {
            changeAlert(true, "error", response.data?.message || response.message || "Error al obtener tareas");
            return false;
        }
    };

    const onHandleUpdateTask = async (row, action) => {
        let request = {}

        switch (action) {
            case "update":
                request = row
                break;
            case "completed":
                request["is_completed"] = true
                request["uuid"] = row
                break;
            case "delete":
                request["is_completed"] = true
                request["archived"] = true
                request["uuid"] = row
                break;
        }
        
        const response = await crmService.current.taskCrmUpdate({data: request});
        if (response.data?.response === "OK") {
            changeAlert(true, 'success', 'El registro se actualizó con éxito');
            return true;
        } else {
            changeAlert(true, "error", response.data?.message || response.message || "Error al obtener tareas");
            return false;
        }
    };

    const onHandleDeleteTask = async (uuid) => {
        let request = {
            filters: {
                uuid: uuid
            }
        };

        const response = await crmService.current.taskCrmDelete(request);
        if (response.data?.response === "OK") {
            changeAlert(true, 'success', 'El registro se eliminó con éxito');
            return true;
        } else {
            changeAlert(true, "error", response.data?.message || response.message || "Error al realizar la acción");
            return false;
        }
    };

    const onHandleCommissionUpdate = async (payload, agent) => {
        let request = {
            detail: payload,
            updated_by:  agent['uuid']
        };

        const response = await crmService.current.commissionCrmUpdate({data: request});
        if (response['data']?.response === 'OK') {
            changeAlert(true, 'success', 'Comisiones asignadas con éxito.');
            return true;
        } else {
            changeAlert(true, 'error', response['message'] || response['data'].message || 'Error al asignar comisiones');
            return false;
        };
    };

    const onHandleGroupUpdate = async (payload) => {
        const response = await crmService.current.leadCrmGroupUpdate({data: payload});
        if (response['data']?.response === 'OK') {
            changeAlert(true, 'success', 'Grupo actualizado con éxito.');
            return true;
        } else {
            changeAlert(true, 'error', response['message'] || response['data'].message || 'Error al actualizar Grupo');
            return false;
        };
    };
    const onHandleGroupDelete = async (payload) => {
        const response = await crmService.current.leadCrmGroupDelete({data: payload});
        if (response['data']?.response === 'OK') {
            changeAlert(true, 'success', 'Grupo eliminado con éxito.');
            return true;
        } else {
            changeAlert(true, 'error', response['message'] || response['data'].message || 'Error al eliminar Grupo');
            return false;
        };
    };
    const onHandleGroupAdd = async (payload) => {
        const response = await crmService.current.leadCrmGroupAdd({data: payload});
        if (response['data']?.response === 'OK') {
            return true;
        } else {
            changeAlert(true, 'error', response['message'] || response['data'].message || 'Error al eliminar Grupo');
            return false;
        };
    };

    useEffect(() => {
        crmService.current = new CrmService(changeAlert);
        commonService.current = new CommonService(changeAlert);
        adminService.current = new AdminService(changeAlert);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        // Lead GET
        handleLeadData,
        handleLeadByUuid,
        handlePartner,
        handleAgentList,
        handleCatalog,
        handleRevenue,
        // Lead UPDATE
        onHandleChangeAgent,
        onHandleChangeStatus,
        onHandleUpdateCompanyContact,
        onHandleLeadUpdate,
        // Task Manager
        onHandleGetTasks,
        onHandleCreateTasks,
        onHandleAddCommentTask,
        onHandleUpdateTask,
        onHandleDeleteTask,
        onHandleCommissionUpdate,
        // Lead Group UPDATE
        onHandleGroupUpdate,
        onHandleGroupDelete,
        onHandleGroupAdd
    }
}